import { gql } from '@apollo/client';

export const DELETE_JOB_NOTIFICATION_DEFERMENT_MUTATION = gql`
  mutation deleteJobNotificationDeferment (
    $jobId: Int!
  ) {
    deleteJobNotificationDeferment(
      jobId: $jobId
    ) {
      success
    }
  }
`;

export const CREATE_JOB_NOTIFICATION_DEFERMENT_MUTATION = gql`
  mutation createJobNotificationDeferment (
    $jobId: Int!
  ) {
    createJobNotificationDeferment(
      jobId: $jobId
    ) {
      success
      deferData {
        id
        deferFrom
        deferUntil
      }
    }
  }
`;
